module.exports = __webpack_public_path__ + "static/media/provider-ludo.7977b960.png";